import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import DestinationsPage from "@/pages/DestinationsPage";
import VisaPage from "@/pages/VisaPage";
import LuxuryPage from "@/pages/LuxuryPage";
import CorporatePage from "@/pages/CorporatePage";
import BlogsPage from "@/pages/BlogsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/destinations" element={<DestinationsPage />} />
            <Route path="/visa" element={<VisaPage />} />
            <Route path="/luxury" element={<LuxuryPage />} />
            <Route path="/corporate" element={<CorporatePage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
